export default {
      id: "icon-fiyat-sor-usage",
      viewBox: "0 0 125.3 126.3",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-fiyat-sor",
      toString: function () {
        return this.url;
      }
    }